export default __webpack_public_path__ + "static/media/instagram-icon.6030a881.png";